import * as React from 'react'
import { Site } from '@envato/foundation-types'

import LoadingCover from '../../loadingCover'
import ExperimentsLoadingCover from '../../experimentsLoadingCover'
import experimentsConfig from '../../../../config/experiments'

import * as styles from './categoryPageWrapper.module.css'

interface IProps {
  children: React.ReactNode
  experimentsReady: boolean
  isLoading: boolean
  currentSite: Site
}

const CategoryPageWrapper = ({
  children,
  experimentsReady,
  isLoading,
  currentSite
}: IProps) => {
  return (
    <section
      className={styles.root}
      role="main"
      data-test-selector="categoryPage"
    >
      <ExperimentsLoadingCover
        experimentsReady={experimentsReady}
        experimentsConfig={experimentsConfig}
        currentSite={currentSite}
      >
        {isLoading && <LoadingCover />}
        {children}
      </ExperimentsLoadingCover>
    </section>
  )
}

export default CategoryPageWrapper
